module.exports = __webpack_public_path__ + "static/img/page7_img6.5136e41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/page7_img6.jpg
// module id = Naue
// module chunks = 1